import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Gear, Help, Logo } from './Icons';

export function Header() {
  const c = useController();
  return (
    <header>
      <div class="brand">
        <Logo class="logo" />
        <h1>{t.appName}</h1>
      </div>
      <button
        type="button"
        class="icon"
        aria-label="Как играть"
        title="Как играть"
        onClick={() => (c.modal.value = 'help')}
      >
        <Help />
      </button>
      <button
        type="button"
        class="icon"
        aria-label="Настройки"
        title="Настройки"
        onClick={() => c.openSettings()}
      >
        <Gear />
      </button>
    </header>
  );
}
